import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { Page$reflection as Page$reflection_1 } from "../ContractType/Model.js";
import { record_type, union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import * as react from "react";
import { dotsLoading } from "../../ViewUtils.js";
import { getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { Locale_get_FromSelectedLanguage } from "../../Utils.js";
import { ContractTypeProps, view as view_1 } from "../ContractType/View.js";
import { MortgageSettingsProps } from "../MortgageSettings/View.js";
import { SubproductDefinitionProps, renderSubproductDefinitions } from "../SubproductDefinition/View.js";
import { deleteSubproductDefinition, createSubproductDefinition, saveSubproductDefinition, loadSubproductDefinitions } from "../SubproductDefinition/Api.js";
import { SubproductsProps, renderSubproducts } from "../Subproducts/View.js";
import { ClientSubproductApi_create, ClientSubproductApi_delete, ClientSubproductApi_update, ClientSubproductApi_load } from "../Subproducts/Api.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { Result_Map } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { SubproductLevel, NormalizedSubproduct_toSubproductDTO_Z60DB963E, NormalizedSubproduct_ofSubproductDTO_Z9763C53 } from "../Subproducts/Model.js";
import { FeeTemplateProps } from "../FeeTemplates/View.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import "../../../src/Containers/Contracts/View.scss";


export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Contracts", "ContractTypeBase", "MortgageSettings", "SubproductDefinitions", "FeeTemplates", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("Containers.Contracts.View.Page", [], Page, () => [[], [["Item", Page$reflection_1()]], [], [], [], []]);
}

export const LazyPages_MortgageSettingsPage = (() => {
    const elemType = react.lazy(() => import("../MortgageSettings/View.js").then((m) => m.view).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export const LazyPages_FeeTemplatesPage = (() => {
    const elemType = react.lazy(() => import("../FeeTemplates/View.js").then((m) => m.view).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export class ContractsProps extends Record {
    constructor(GlobalDependencies, CurrentContractsPage) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.CurrentContractsPage = CurrentContractsPage;
    }
}

export function ContractsProps$reflection() {
    return record_type("Containers.Contracts.View.ContractsProps", [], ContractsProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["CurrentContractsPage", Page$reflection()]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_8, children_6;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    let contentHtml;
    const matchValue = props.CurrentContractsPage;
    switch (matchValue.tag) {
        case 1: {
            contentHtml = view_1(new ContractTypeProps(props.GlobalDependencies, matchValue.fields[0]));
            break;
        }
        case 2: {
            contentHtml = LazyPages_MortgageSettingsPage(new MortgageSettingsProps(props.GlobalDependencies));
            break;
        }
        case 3: {
            const children_10 = [renderSubproductDefinitions(new SubproductDefinitionProps(() => loadSubproductDefinitions(props.GlobalDependencies.ClientNr), (product, name, dto) => saveSubproductDefinition(props.GlobalDependencies.ClientNr, product, name, dto), (dto_1) => createSubproductDefinition(props.GlobalDependencies.ClientNr, dto_1), (name_1, productNr) => deleteSubproductDefinition(props.GlobalDependencies.ClientNr, name_1, productNr), props.GlobalDependencies.IsAdminUser)), (children_8 = [(children_6 = [getTranslationFrom(translationsLoadState, "Contracts.SubproductDefinitions.ClientSubproducts")], react.createElement("h2", {
                ["data-translation"]: "Contracts.SubproductDefinitions.ClientSubproducts",
            }, ...children_6)), renderSubproducts(new SubproductsProps(() => {
                const a = ClientSubproductApi_load(props.GlobalDependencies.ClientNr);
                return singleton.Delay(() => singleton.Bind(a, (_arg) => singleton.Return(Result_Map((list) => map(NormalizedSubproduct_ofSubproductDTO_Z9763C53, list), _arg))));
            }, (name_2, product_1, activeFrom, normalizedSubproduct) => ClientSubproductApi_update(props.GlobalDependencies.ClientNr, name_2, product_1, activeFrom, NormalizedSubproduct_toSubproductDTO_Z60DB963E(normalizedSubproduct)), (subproductName, product_2, activeFrom_1) => ClientSubproductApi_delete(props.GlobalDependencies.ClientNr, subproductName, product_2, activeFrom_1), (arg_2) => ClientSubproductApi_create(props.GlobalDependencies.ClientNr, NormalizedSubproduct_toSubproductDTO_Z60DB963E(arg_2)), () => loadSubproductDefinitions(props.GlobalDependencies.ClientNr), locale, new SubproductLevel(0), props.GlobalDependencies.IsAdminUser))], react.createElement("div", {
                className: "mt-4 contracts__subproducts",
            }, ...children_8))];
            contentHtml = react.createElement("div", {
                className: "container-main container-main--padded contracts__subproducts",
            }, ...children_10);
            break;
        }
        case 4: {
            const children_12 = [LazyPages_FeeTemplatesPage(new FeeTemplateProps(props.GlobalDependencies))];
            contentHtml = react.createElement("div", {
                className: "container-main container-main--padded",
            }, ...children_12);
            break;
        }
        case 5: {
            const children_16 = [react.createElement("h2", {}, "Not found")];
            contentHtml = react.createElement("div", {}, ...children_16);
            break;
        }
        default: {
            const children_4 = [react.createElement("h2", {}, "Contracts"), react.createElement("p", {}, "This page is currently work-in-progress.")];
            contentHtml = react.createElement("div", {}, ...children_4);
        }
    }
    return react.createElement("div", {
        className: "contracts",
    }, contentHtml);
}, void 0, uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Contracts\\View.fs", 118);

